export const getImageUrl = (path) => {
  if (!path) return '';
  if (path.startsWith('http')) return path;
  
  const apiUrl = (window.ENV && window.ENV.REACT_APP_API_URL) || 
                 process.env.REACT_APP_API_URL || 
                 window.location.origin.replace(':3000', ':5000');
  
  return `${apiUrl}${path}`;
};
